import { Component, OnInit, ViewChild } from '@angular/core';
import { Checkbox } from 'primeng/checkbox';
import { ScrBaseComponent } from '../../../base.component';
import { ScrEnvironment } from '../../../../../environments/environment';
import { AccountService, CreateAccountRequest } from '../../../../services/account.service';
import { CreateAccountService } from '../../../../services/createaccount.service';
import { NgForm } from '@angular/forms';
import { ScrAuthenticationService } from '../../../../services/authentication.service';
import { Aggregator, ConfigService } from '../../../../services/config.service';
import { ProgramTypeReviewStatus, ShortCodesRole } from '../../../../models/constants';
import { Address } from '../../../../services/address-book.service';
import { Chips, ChipsAddEvent } from 'primeng/chips';
import { StringOrPhoneNumber } from 'src/app/models/common.model';
import { isArray } from 'lodash-es';
import { handleEnterKeyPress } from 'src/app/shared/common-events';
import { ProgramType } from '../../../../models/constants';
import { Account } from '../../../../models/account.model';
import { DropdownChangeEvent } from 'primeng/dropdown';

@Component({
  templateUrl: './edit-account.component.html',
  styleUrls: ['./edit-account.component.scss']
})
export class EditAccountComponent extends ScrBaseComponent implements OnInit {
  CognitoGroup: typeof ShortCodesRole = ShortCodesRole;
  JSON = JSON;

  public model = new Account();
  public submitted = false;
  public isDisplay = false;
  public updateOrdersApplicantContact = false;
  public updateOrdersBillingContact = false;
  @ViewChild('recipientsCWR') recipientsCWR!: Chips;

  public termAgreement = false;
  public legalEntityTypes: string[] = [];
  public ecosystemRoles!: string[];
  public disableSmbFields = false;

  @ViewChild('termAgreement') termAgreementcheckbox?: Checkbox;
  @ViewChild('bestPractices') bestPracticescheckbox?: Checkbox;

  public confirmPasswordFocused = false;
  public dummy: {
    governmentTerms: boolean,
    charityTerms: boolean
  } = { governmentTerms: false, charityTerms: false };

  public licenseAgreementDate?: string;
  public licenseAgreementcontent?: string;
  public originalProgramTypeRequested?: string;

  bestPractices?: boolean;
  bestPracticesContent?: string;
  bestPracticesDate?: string;

  public aggregators: Aggregator[] = [];
  public publicEmailDomains: string[] = [];
  public billingOnRenew = [{
    label: 'Billing Info on previous order',
    value: false
  }, {
    label: 'Primary Billing Contact from the account information',
    value: true
  }];

  constructor(
    public service: ScrAuthenticationService,
    public createAccountService: CreateAccountService,
    public accountService: AccountService,
    public configService: ConfigService,
    public env: ScrEnvironment) {
    super();
  }

  ngOnInit(): void {
    this.configService.getConfig().subscribe(cfg => {
      this.licenseAgreementDate = cfg.licenseAgreement.updated;
      this.licenseAgreementcontent = cfg.licenseAgreement.content;
      this.legalEntityTypes = cfg.legalEntityTypes;
      this.ecosystemRoles = cfg.ecosystemRoles;
      this.publicEmailDomains = cfg.publicEmailDomains;
      this.bestPracticesContent = cfg.bestPractices.content;
      this.bestPracticesDate = cfg.bestPractices.updated;
    });

    this.accountService.getAccount(true).subscribe(response => {
      this.updateModelFromAccount(response.account);
      this.isDisplay = true;
    });
    this.configService.getAggregators().subscribe(res => {
      this.aggregators = res.filter(aggregator => aggregator.aggregatorId != 9999);
    });
  }

  updateModelFromAccount(account: Account): void {
    this.model = Object.assign({}, account);
    // keep the original for the radio button display.
    this.originalProgramTypeRequested = account.programTypeRequested;
    if (!this.model.country)
      this.model.country = 'us';
    if (!this.model.billingCountry)
      this.model.billingCountry = 'us';

    this.disableSmbFields = account.programTypeRequested === ProgramType.SMB &&
      account.programTypeReviewStatus === ProgramTypeReviewStatus.Pending;

    if (account.programTypeReviewStatus === ProgramTypeReviewStatus.Pending &&
      account.programTypeRequested === ProgramType.Government) {
      // pending government, terms and conditions will be disabled so check it.
      this.dummy.governmentTerms = true;
    }
    if (account.programTypeReviewStatus === ProgramTypeReviewStatus.Pending &&
      account.programTypeRequested === ProgramType.Charity) {
      // pending government, terms and conditions will be disabled so check it.
      this.dummy.charityTerms = true;
    }
  }
  /**
   * User has selected an address from their address book to fill in billing information.
   * @param address - address book address.
   */
  loadAddress(address: Address) {
    this.model.billingFirstName = address.firstName;
    this.model.billingLastName = address.lastName;
    this.model.billingPhone = address.phone;
    this.model.billingPhoneExtension = address.phoneExtension;
    this.model.billingEmail = address.email;
    this.model.billingAddress1 = address.address1;
    this.model.billingAddress2 = address.address2;
    this.model.billingCity = address.city;
    this.model.billingState = address.state;
    this.model.billingZip = address.zip;
    this.model.billingCountry = address.country;
  }

  agencyTypeChanged() {
    delete this.model.governmentExplain;
  }

  programTypeChanged() {
    this.model.governmentAgencyType = '';
    this.model.governmentExplain = '';
    this.model.governmentAgencyWebsite = '';
    this.model.governmentAdditionalInfo = '';
    this.dummy.governmentTerms = false;
    this.model.charityAccreditation = '';
    this.model.charityAdditionalInfo = '';
    this.dummy.charityTerms = false;
  }

  modelData(): CreateAccountRequest {
    const ret: Record<string, StringOrPhoneNumber | number | string | boolean | string[] | number[] | null> = { ...this.model };

    if (ret.phone && typeof ret.phone === 'object' && !isArray(ret.phone)) {
      ret.phone = ret.phone.e164Number;
    }

    if (ret.secondaryPhone && typeof ret.secondaryPhone === 'object' && !isArray(ret.secondaryPhone)) {
      ret.secondaryPhone = ret.secondaryPhone.e164Number;
    }

    if (ret.billingPhone && typeof ret.billingPhone === 'object' && !isArray(ret.billingPhone)) {
      ret.billingPhone = ret.billingPhone.e164Number;
    }

    if (ret.governmentAgencyType !== 'Other')
      ret.governmentExplain = '';

    for (const i in ret) {
      // if empty string, set to null.
      if (ret[i] === '') {
        ret[i] = null;
      }
    }

    return ret;
  }

  updateAccount({ form }: NgForm) {
    if (form.controls['termAgreement'] !== undefined) {
      if (!this.termAgreement) {
        form.controls['termAgreement'].setErrors({ notValid: true });
      }
      else {
        form.controls['termAgreement'].setErrors(null);
      }
      if (this.model.programTypeRequested == 'Government' && form.controls['governmentTermsid'] !== undefined) {
        if (!this.dummy.governmentTerms) {
          form.controls['governmentTermsid'].setErrors({ notValid: true });
        }
        else {
          form.controls['governmentTermsid'].setErrors(null);
        }
      }
      if (this.model.programTypeRequested == 'Charity' && form.controls['charityTermsid'] !== undefined) {
        if (!this.dummy.charityTerms) {
          form.controls['charityTermsid'].setErrors({ notValid: true });
        }
        else {
          form.controls['charityTermsid'].setErrors(null);
        }
      }
    }
    this.clearMessages();
    form.markAllAsTouched();
    for (const name in form.controls) {
      form.controls[name].markAsDirty();
    }

    if (form.invalid) {
      this.submitted = true;
      this.scrollToFirstError();
    }
    else {
      this.observe(this.createAccountService.updateAccount(this.modelData(), this.updateOrdersApplicantContact, this.updateOrdersBillingContact), (rsp) => {
        this.submitted = false;
        this.termAgreement = false;
        this.bestPractices = false;
        this.dummy.governmentTerms = false;
        this.dummy.charityTerms = false;
        if (form.controls['termAgreement'] !== undefined) {
          form.controls['termAgreement'].markAsPristine();
          form.controls['termAgreement'].markAsUntouched();
        }
        if (form.controls['bestPractices'] !== undefined) {
          form.controls['bestPractices'].markAsPristine();
          form.controls['bestPractices'].markAsUntouched();
        }
        if (form.controls['governmentTermsid']) {
          form.controls['governmentTermsid'].markAsPristine();
          form.controls['governmentTermsid'].markAsUntouched();
        }
        if (form.controls['charityTermsid']) {
          form.controls['charityTermsid'].markAsPristine();
          form.controls['charityTermsid'].markAsUntouched();
        }
        if (rsp.account) {
          this.updateModelFromAccount(rsp.account);
        }
      });
    }
  }

  validateChipFormat(event: ChipsAddEvent) {
    const isEmail = /^\w+([-+.'`!#$%^&*]\w+)*@\w+([-.]\w+)*\.\w\w+$/.test(event.value);
    const publicDomain = event.value && this.publicEmailDomains && this.publicEmailDomains.some(val => event.value?.toLowerCase().includes(val?.toLowerCase()));
    if (!isEmail || publicDomain) {
      this.model.carrierWeeklyReportEmailList?.pop();
    }
  }

  handleEnter(event: Event) {
    handleEnterKeyPress(event);
  }

  onChangeDropdown(event: DropdownChangeEvent) {
    if (!event.value)
      this.model.legalEntityType = undefined;
  }
}

